<!-- Communication Component Builder -->

<template>
	<div class="main">
		<div class="title wi8_font">Communication Builder</div>
			
			<input id="wait_id" />
			<button @click="goWait">Wait</button>
			wait = {{ wait }} 

			<br/><br/>

			<button @click="goReqCats">Cats</button><br/>
			<button @click="goReqStats">Stats</button><br/>
			<button @click="goReqBad">Bad Req</button><br/>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState('api', ['wait']),
	 },
	 methods: {
		 goWait() {
			 m("go wait");
			 let wait_id = document.getElementById("wait_id").value;
			 if (wait_id.length>0) {
				 this.$store.dispatch('api/toggleWait', wait_id);
			 } else {
				 this.$store.dispatch('api/toggleWait');
			 }
		 },
		 goReqCats() {
			 m("goReqCats");
			let dat = {
				"form_name": "cats_list",
				// "cat_id": "home",
			}
			this.$store.dispatch('api/sendRequest', dat);
		 },
		 goReqStats() {
			 m("goReqStats");
			let dat = {
				"form_name": "site_stats",
			}
			this.$store.dispatch('api/sendRequest', dat);
		 },
		 goReqBad() {
			 m("goReqBad");
			let dat = {
				"form_name": "XXX",
			}
			this.$store.dispatch('api/sendRequest', dat);
		 },
	 }
}
</script>


<style scoped>
	.main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #966;
	}
	button {
		width: 100px;
	}
</style>
